module.exports = __webpack_public_path__ + "assets/read-aloud-inactive.ea8225c0.svg";